/* eslint-disable */
export default () => window.crypto.getRandomValues(new Uint8Array(16));
